import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Cleveland_Clinic_Abu-Dhabi.webp';

const Project_Four = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Cleveland Clinic Abu Dhabi</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The largest structural steel building in the UAE at 30,000+ tonnes, developed by Mubadala Healthcare. A world-class
                multi-specialty hospital spanning 400,000+ sqm with 364 beds, 26 surgical suites and 8 buildings including a dedicated
                Central Utility Building. LEED Gold certified. Opened 2015.</p>
              <p>MAIN CONTRACTOR : BESIX (Six Construct)</p>
              <p>MEP CONTRACTOR : ETA</p>
              <p>GEMCO SCOPE OF WORKS : Main central plant room and multiple secondary plant
                rooms across the hospital complex</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_Four